import React, { useEffect, useState } from "react";
import { X, Megaphone, Calendar, Trophy, Handshake, Info } from "lucide-react";
import { fetchPublic } from "../adminApi";

const STORAGE_KEY = "sc_ticker_on";

const TYPE_META = {
  schedule: { icon: Calendar, label: "Schedule", color: "#c8f000" },
  event: { icon: Trophy, label: "Event", color: "#d96e2b" },
  sponsor: { icon: Handshake, label: "Partner", color: "#8fd3ff" },
  general: { icon: Info, label: "News", color: "#f4f1e6" },
};

function Item({ a }) {
  const meta = TYPE_META[a.type] || TYPE_META.general;
  const Icon = meta.icon;
  const inner = (
    <span className="inline-flex items-center gap-3 px-8 border-r border-white/10">
      {a.logo ? (
        <img src={a.logo} alt="" className="h-6 w-auto max-w-[120px] object-contain" />
      ) : (
        <Icon className="w-4 h-4 shrink-0" style={{ color: meta.color }} />
      )}
      <span className="font-grotesk uppercase text-[11px] tracking-[0.18em] shrink-0" style={{ color: meta.color }}>
        {meta.label}
      </span>
      <span className="font-grotesk text-sm text-white/85 whitespace-nowrap">{a.text}</span>
    </span>
  );
  if (a.link) {
    return <a href={a.link} target="_blank" rel="noreferrer" className="hover:opacity-80 transition-opacity">{inner}</a>;
  }
  return inner;
}

export default function AnnouncementTicker() {
  const [items, setItems] = useState([]);
  const [on, setOn] = useState(() => {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === null ? true : v === "true";
  });

  useEffect(() => {
    fetchPublic("announcements").then(setItems).catch(() => setItems([]));
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(on));
  }, [on]);

  if (!items.length) return null;

  const loop = [...items, ...items];

  return (
    <section className="relative border-y border-white/10 bg-[#06170f]/45 backdrop-blur-md">
      {on ? (
        <div className="flex items-stretch">
          <div className="hidden sm:flex items-center gap-2 px-5 py-3 bg-white/5 border-r border-white/10 shrink-0">
            <Megaphone className="w-4 h-4 text-sc-lime" />
            <span className="font-grotesk uppercase text-[11px] tracking-[0.2em] text-sc-lime">Live</span>
          </div>
          <div className="flex-1 overflow-hidden py-3">
            <div className="d2-marquee items-center">
              {loop.map((a, i) => <Item key={`${a.id}-${i}`} a={a} />)}
            </div>
          </div>
          <button
            onClick={() => setOn(false)}
            aria-label="Hide announcements"
            className="px-4 flex items-center gap-1.5 text-white/50 hover:text-sc-lime transition-colors border-l border-white/10 shrink-0"
          >
            <X className="w-4 h-4" />
            <span className="hidden md:inline font-grotesk uppercase text-[10px] tracking-widest">Hide</span>
          </button>
        </div>
      ) : (
        <div className="flex items-center justify-center py-2">
          <button
            onClick={() => setOn(true)}
            className="inline-flex items-center gap-2 text-white/60 hover:text-sc-lime transition-colors"
          >
            <Megaphone className="w-4 h-4" />
            <span className="font-grotesk uppercase text-[11px] tracking-[0.2em]">Show announcements</span>
          </button>
        </div>
      )}
    </section>
  );
}
